import { ReactNode } from 'react';

import DefaultLayout from '../layout/DefaultLayout';
import Setting from '../page/Settings/Settings';
import Calendar from '../page/Calendar';
import BacklogIndex from '../role/Admin/Backlog';
import ClientIndex from '../role/Admin/Client';
import { AddClientIndex } from '../role/Admin/Client/Components/AddClient';
import DailyTaskIndex from '../role/Admin/DailyTask';
import Dashboard from '../role/Admin/Dashboard/Dashboard';
import DocumentIndex from '../role/Admin/Document';
import { AddDocumentIndex } from '../role/Admin/Document/Components/AddDocument';
import EmployeeIndex from '../role/Admin/Employee';
import { AddEmployeeIndex } from '../role/Admin/Employee/Components/AddEmployee';
import LeaveAdmin from '../role/Admin/Leave/Components/Leave';
import ProjectIndex from '../role/Admin/Project';
import { AddProjectIndex } from '../role/Admin/Project/Components/AddProject';
import TaskSheetIndex from '../role/Admin/Tasksheet';
import { AddTaskSheetIndex } from '../role/Admin/Tasksheet/Components/AddTasksheet';
import TaskDetail from '../role/Admin/Tasksheet/Components/TaskDetail';
import WeeklyGol from '../role/Admin/WeeklyGol/Index';
import LeadIndex from '../role/Bde/Lead';
import { AddLeadIndex } from '../role/Bde/Lead/Components/AddLead';
import LeadDetail from '../role/Bde/Lead/Components/LeadDetail';
import LeadTracker from '../role/Bde/Lead/Components/LeadTracker';
import EmpDailyTaskIndex from '../role/Employee/DailyTask';
import EmpDocumentIndex from '../role/Employee/Document';
import AddLeaveRequest from '../role/Employee/Leave/Components/AddLeaveRequest/AddLeaveRequest';
import Leave from '../role/Employee/Leave/Components/Leave';
import EmpTaskSheetIndex from '../role/Employee/Tasksheet';
import {
    AddTaskSheetIndex as AddEmpTaskSheetIndex
} from '../role/Employee/Tasksheet/Components/AddTasksheet';
import Holidays from '../role/Hr/Holidays';
import SalarySlip from '../role/Hr/SalarySlip';
import Profile from '../user/profile/Profile';
import { Roles } from '../util/constant';
import Hiring from '../role/Admin/HiringEmployee/Hiring';
import AddHiring from '../role/Admin/HiringEmployee/AddHiring';
import EditHiring from '../role/Admin/HiringEmployee/EditHiring';
import Contact from '../role/Admin/Contact/Contact';
import AddContact from '../role/Admin/Contact/component/AddContact/AddContact';
import EditContact from '../role/Admin/Contact/component/EditContact/EditContact';
import BdeForm from '../role/Bde/Lead/BDE-Form/BdeForm';
import Campaign from '../role/Bde/Lead/Campaign/Campaign';
import CampaignData from '../role/Bde/Lead/Campaign/CampaignData/CapmaignData';
import Schedule from '../role/Bde/Lead/Campaign/CampaignData/Schedule';
import CampaignDetails from '../role/Bde/Lead/Campaign/CampaignData/CampaignDetails';
import CategoryRecorderPage from '../role/Admin/ScreenRecorder/CategoryRecorderPage';
import ManageVideoCategories from '../role/Admin/ScreenRecorder/ManageVideoCategories';
import Jibble from '../role/Admin/Jibble/Jibble';

export const commonRoutes = [
  {
    path: "/profile",
    element: <Profile />,
    },
    {
      path: "/calendar",
      element: <Calendar />,
    },

  {
    path: "/video-recorder",
    element: <CategoryRecorderPage />,
  },
  {
    path: "/video-categories",
    element: <ManageVideoCategories />,
  },
  {
    path: "/WeeklyGoal",
    element: <WeeklyGol />,
  },
  {
    path: "/lead",
    element: <LeadIndex />,
  },
  {
    path: "/lead-tracker",
    element: <LeadTracker />,
  },
  {
    path: "/bde-eod",
    element: <BdeForm />,
  },
  {
    path: "/addLead",
    element: <AddLeadIndex />,
  },
  {
    path: "holidays",
    element: <Holidays />,
  },
  {
    path: "/task/:id",
    element: <TaskDetail />,
  },
  {
    path: "/lead/:id",
    element: <LeadDetail />,
  },
  {
    path: "/hiring",
    element: <Hiring />,
  },
  {
    path: "/addHiring",
    element: <AddHiring />,
  },
  {
    path: "/edit-hiring/:id",
    element: <EditHiring />,
  },
  {
    path: "/jibble",
    element: <Jibble />,
  },

];

export const adminRoutes = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/dashBoard",
    element: <Dashboard />,
  },
  {
    path: "/taskSheet",
    element: <TaskSheetIndex />,
  },
  
  {
    path: "/employee",
    element: <EmployeeIndex />,
  },
  {
    path: "/addEmployee",
    element: <AddEmployeeIndex />,
  },
  {
    path: "/dailyTask",
    element: <DailyTaskIndex />,
  },
  {
    path: "/backlog",
    element: <BacklogIndex />,
  },
  {
    path: "/project",
    element: <ProjectIndex />,
  },
  {
    path: "/addProject",
    element: <AddProjectIndex />,
  },
  {
    path: "/document",
    element: <DocumentIndex />,
  },
  {
    path: "/addDocument",
    element: <AddDocumentIndex />,
  },
  {
    path: "/client",
    element: <ClientIndex />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/addContact",
    element: <AddContact />,
  },
  {
    path: "/edit-contact/:id",
    element: <EditContact />,
  },
  {
    path: "/addClient",
    element: <AddClientIndex />,
  },
  {
    path: "/addTaskSheetAdmin",
    element: <AddTaskSheetIndex />,
  },
  {
    path: "/leave",
    element: <LeaveAdmin />,
  },
  {
    path: "/salary-slip",
    element: <SalarySlip />,
  },
  {
    path: "/pages/settings",
    element: <Setting />,
  },
  {
    path: "/campaign",
    element: <CampaignData />,
  },
  {
    path: "/campaign-list/:id",
    element: <Campaign />,
  },
  {
    path: "/campaign-schedule/:id",
    element: <Schedule />,
  },
  {
    path: "/campaign-details/:id",
    element: <CampaignDetails />,
  },
  {
    path: "/jibble",
    element: <Jibble />,
  },
];

export const employeeRoutes = [
  {
    path: "/",
    element: <EmpTaskSheetIndex />,
  },
  {
    path: "/dailyTask",
    element: <EmpDailyTaskIndex />,
  },
  {
    path: "/taskSheet",
    element: <EmpTaskSheetIndex />,
  },
  {
    path: "/addTaskSheet",
    element: <AddEmpTaskSheetIndex />,
  },
  {
    path: "/document",
    element: <EmpDocumentIndex />,
  },
  {
    path: "/leave",
    element: <Leave />,
  },
  {
    path: "/add-leave-request",
    element: <AddLeaveRequest />,
  },
  {
    path: "/tlTaskView",
    element: <TaskSheetIndex />,
  },
  {
    path: "/addTaskSheetAdmin",
    element: <AddTaskSheetIndex />,
  },
  {
    path: "/campaign",
    element: <CampaignData />,
  },
  {
    path: "/campaign-list/:id",
    element: <Campaign />,
  },
  {
    path: "/campaign-schedule/:id",
    element: <Schedule />,
  },
  {
    path: "/jibble",
    element: <Jibble />,
  }
  
];

// HR specific routes
export const hrRoutes = [
  {
    path: "/hrTaskView",
    element: <DailyTaskIndex />,
  },
  {
    path: "/hr-leave",
    element: <LeaveAdmin />,
  },
  {
    path: "/salary-slip",
    element: <SalarySlip />,
  },
  {
    path: "/employee",
    element: <EmployeeIndex />,
  },
  {
    path: "/addEmployee",
    element: <AddEmployeeIndex />,
  },
  {
    path: "/campaign",
    element: <CampaignData />,
  },
  {
    path: "/campaign-list/:id",
    element: <Campaign />,
  },
  {
    path: "/campaign-schedule/:id",
    element: <Schedule />,
  },
  {
    path: "/campaign-details/:id",
    element: <CampaignDetails />,
  },
  {
    path: "/jibble",
    element: <Jibble />,
  }
];

export const wrapWithLayout = (
  routes: { path: string; element: ReactNode }[]
) => {
  return routes.map(({ path, element }) => ({
    path,
    element: <DefaultLayout>{element}</DefaultLayout>,
  }));
};

export const getRoutesByRole = (role: string) => {
  const routes = [...commonRoutes];

  switch (role) {
    case Roles.admin:
      routes.push(...adminRoutes);
      break;
    case Roles.employee:
      routes.push(...employeeRoutes);
      break;
    case Roles.hr:
      routes.push(...employeeRoutes, ...hrRoutes);
      break;
    default:
      break;
  }

  return wrapWithLayout(routes);
};
